<template>
  <div style="display: flex; flex-direction: column; margin: 20px">
    <v-card class="mb-3" outlined>
      <v-card-title class="py-2">
        <v-icon left>mdi-filter</v-icon>
        {{ $t("_alarm_filters_") }}      

        <v-btn icon @click="showFilters = !showFilters">
          <v-icon>
            {{ showFilters ? "mdi-chevron-up-circle" : "mdi-chevron-down-circle" }}
          </v-icon>
        </v-btn>
      </v-card-title>

      <v-expand-transition>
        <div v-show="showFilters">
          <v-divider />

          <v-card-text>
            <!------------Date range start------------------>
            <v-row class="mb-3">
              <v-col cols="12" md="3">
                <div class="d-flex align-center">
                  <v-btn icon class="mr-2" @click.stop="resetDate">
                    <v-icon>mdi-calendar-refresh</v-icon>
                  </v-btn>
                  <v-menu
                    v-model="menuRange"
                    :close-on-content-click="false"
                    offset-y
                    transition="scale-transition"
                    min-width="290"
                    @input="onMenuChange"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedDateRange"
                        readonly
                        dense
                        hide-details
                        class="flex-grow-1"
                        v-bind="attrs"
                        v-on="on"
                      />
                    </template>

                    <v-card>
                      <v-date-picker
                        v-model="tempDateRange"
                        range
                        :max="maxDate"
                      />

                      <v-divider />

                      <v-card-actions>
                        <v-spacer />

                        <v-btn text color="grey" @click="cancelDateRange">
                          {{ $t("_annuler_") }}
                        </v-btn>

                        <v-btn
                          text
                          color="primary"
                          :disabled="tempDateRange.length !== 2"
                          @click="validateDateRange"
                        >
                          {{ $t("_valider_") }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-menu>
                </div>
              </v-col>
            </v-row>
            <!------------Date range end------------------>
            <!-------------------------------------------->
            <!------------Criticite selector--------------->
            <v-row class="mb-3">
              <v-col cols="12" md="3">
                <v-select
                  v-model="selectedCriticity"
                  :items="criticityOptions"
                  :label="$t('_criticite_')"
                  clearable
                  dense
                />
              </v-col>
              <!------------sub categorie selector--------------->
              <v-col cols="12" md="4">
                <v-autocomplete
                  v-model="selectedChecklist"
                  :items="checklistOptions"
                  :label="$t('_sub_categorie_')"
                  clearable
                  dense
                />
              </v-col>
            </v-row>
            <!------------end of selector--------------->
            <!------------------------------------------>
            <!--------------card selector for losses---------------------------->
            <v-card flat class="mb-3 pa-2 grey lighten-4">
              <v-row>
                <v-col cols="6">
                  <strong>{{ $t("_pertes_kwh_") }} :</strong>
                  {{ totalPertes.toFixed(0) }}
                </v-col>
                <!--------------card selector for cost---------------------------->
                <v-col cols="6">
                  <strong>{{ $t("_cout_") }} :</strong>
                  {{ totalCost.toFixed(0) }}
                </v-col>
              </v-row>
            </v-card>
          </v-card-text>
        </div>
      </v-expand-transition>
    </v-card>

    <v-data-table
      :headers="visibleHeaders"
      :items="filteredItems"
      :key="filteredItems.length"
      style="width: 100%"
      :footer-props="{
        'items-per-page-options': [5, 20, 50, 100, -1],
        'items-per-page-text': this.$t('_lignes_par_page_'),
      }"
      :items-per-page="5"
      :item-key="'id'"
      :single-expand="true"
      :expanded.sync="alarmExpanded"
      show-expand
      dense
    >
      <template v-slot:item.cat_checklist="{ item }">
        <icon
          v-if="item.cat_checklist"
          :icon="getIconifyIcon(item.cat_checklist)"
          :height="20"
          :color="'#000'"
        />
      </template>
      <template v-slot:header.status="{ header }">
        <v-tooltip bottom max-width="350">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              {{ header.text }}
              <!----<v-icon small class="ml-1">mdi-information-outline</v-icon>-->
            </span>
          </template>

          <span>
            {{ $t("_warning_status_") }}<br /><br />
            <!----<strong>{{ $t("_ouvert_") }}</strong> :
            {{
              $t(
                "_la_date_de_fermeture_est_vide_ou_posterieure_(_ou_egale_)_a_la_fin_de_la_periode_selectionnee_"
              )
            }}<br /><br />
            <strong>{{ $t("_ferme_") }}</strong> :
            {{
              $t(
                "_la_date_de_fermeture_est_anterieure_a_la_fin_de_la_periode_selectionnee_"
              )
            }}------>
          </span>
        </v-tooltip>
      </template>
      <template v-slot:item.site="{ item }">
        <span style="cursor: pointer" @click.stop="goToInstallation(item)">
          {{ item.site }}
        </span>
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td :colspan="headers.length">
          <ul class="mx-0 my-2" style="line-height: 1.25rem">
            <li v-for="msg in splitBySeparator(item.message, '\n')" :key="msg">
              {{ msg }}
            </li>
          </ul>
        </td>
      </template>
    </v-data-table>
    <!--<v-btn style="width: 300px;">{{ $t("_telecharger_le_tableau_comparatif_") }}</v-btn>-->
  </div>
</template>

<script>
import { Icon } from "@iconify/vue2";
import api from "@/api/api";
import { mapGetters } from "vuex";
export default {
  components: {
    Icon,
  },
  props: {
    liste_alarmes: { type: Array, default: () => [] },
    activeButton: {
      type: Number,
    },

    selected_date: {
      type: String,
    },
    selected_site_id: { type: Array, default: () => [] },
  },
  data() {
    return {
      headers: [],
      items: [],
      alarmExpanded: [],
      selectedCriticity: null,
      selectedChecklist: null,
      activeDateRange: null,
      tempDateRange: [],
      dateRange: [],
      menuRange: false,
      loading: false,
      showFilters: false,
      maxDate: new Date(Date.now() - 86400000).toISOString().substr(0, 10),
    };
  },
  mounted() {
    if (!this.selected_date) {
      this.resetDate();
    }
  },
  computed: {
    ...mapGetters(["role", "cur_install_id", "constants", "installations"]),
    visibleHeaders() {
      // Adjust the headers based on which button is active
      if (this.activeButton === 2) {
        return this.headers;
      } else {
        // Show reduced headers for evolution
        return this.headers.slice(0, 5); // For example, show only the first 5 headers
      }
    },
    criticityOptions() {
      return [
        {
          text: this.$t("_severe_"),
          value: "_severe_",
        },
        {
          text: this.$t("_critique_"),
          value: "_critique_",
        },
      ];
    },
    checklistOptions() {
      return [...new Set(this.items.map((i) => i.checklist_desc))].sort();
    },
    filteredItems() {
      return this.items.filter((item) => {
        const criticityOk =
          !this.selectedCriticity ||
          item.criticity_info === this.selectedCriticity;

        const checklistOk =
          !this.selectedChecklist ||
          item.checklist_desc === this.selectedChecklist;

        return criticityOk && checklistOk;
      });
    },
    totalPertes() {
      return this.filteredItems.reduce(
        (sum, item) => sum + Number(item.pertes || 0),
        0
      );
    },

    totalCost() {
      return this.filteredItems.reduce(
        (sum, item) => sum + Number(item.cost || 0),
        0
      );
    },
    formattedDateRange() {
      if (this.dateRange.length !== 2) return "";

      return `${this.dateRange[0]} → ${this.dateRange[1]}`;
    },

    startDate() {
      return this.dateRange?.[0] || null;
    },

    endDate() {
      return this.dateRange?.[1] || null;
    },
  },
  watch: {
    liste_alarmes: {
      immediate: true,
      handler(newVal) {
        if (!newVal || newVal.length === 0) {
          this.items = [];
          this.alarmExpanded = [];
          return;
        }

        this.items = this.mapAlarms(newVal);
      },
    },

    activeButton: {
      handler() {
        this.visibleHeaders;
      },
    },
    selected_date: {
      handler(val) {
        this.refresh_header_values();
        if (val) {
         this.setDateRange(val)
        }
      },
      immediate: true,
    },
    "$root.$i18n.locale": {
      handler() {
        this.refresh_header_values();
      },
      immediate: true,
    },
    selected_site_id: {
      async handler() {
        this.items = [];
        this.alarmExpanded = [];
      },
      immediate: true,
    },
  },
  methods: {
    setDateRange(date) {
      this.dateRange = [date, date];
      this.tempDateRange = [date, date];
      this.activeDateRange = [date, date];
    },
    mapAlarms(alarms) {
      return alarms.map((alarm, index) => ({
        id: index,
        installation_id: alarm.installation_id,
        message: alarm.message,
        site: alarm.site,
        cat_checklist: alarm.icon,
        checklist_desc: alarm.checklist_desc,
        alarm_type: alarm.alarm_type,
        icon_height: alarm.icon_height,
        criticity: alarm.criticity,
        criticity_info: alarm.criticity_info,
        status: alarm.status,
        open_date: alarm.open_date,
        close_date: alarm.close_date,
        pertes: alarm.pertes,
        cost: alarm.cost,
        loss_frac: alarm.loss_frac,
      }));
    },
    resetDate() {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);

      const date = yesterday.toISOString().slice(0, 10);

      this.dateRange = [date, date];
      this.tempDateRange = [date, date];
    },
    splitBySeparator(item, sep) {
      if (item !== undefined) {
        return item.split(sep).filter(Boolean);
      } else {
        return "";
      }
    },
    refresh_header_values() {
      this.headers = [
        { text: this.$t("_site_"), value: "site" },
        {
          text: this.$t("_categorie_"),
          align: "start",
          sortable: false,
          value: "cat_checklist",
        },
        { text: this.$t("_sub_categorie_"), value: "checklist_desc" },
        { text: this.$t("_type_d_alarme_"), value: "alarm_type" },
        { text: this.$t("_criticite_"), value: "criticity" },
        { text: this.$t("_date_d_ouverture_"), value: "open_date" },
        { text: this.$t("_date_de_fermeture_"), value: "close_date" },
        { text: this.$t("_statut_"), value: "status" },
        { text: this.$t("_pertes_kwh_"), value: "pertes" },
        { text: this.$t("_cout_"), value: "cost" },
        { text: this.$t("_pertes_frac_"), value: "loss_frac" },
      ];
    },

    getIconifyIcon(iconString) {
      const [library, iconName] = iconString.split(":"); // Split library and icon name
      switch (library) {
        case "tabler":
        case "iconoir":
        case "game-icons":
          return `${library}:${iconName}`;

        case "carbon":
          return "carbon:data-blob";

        default:
          return null;
      }
    },
    goToInstallation(item) {
      const installation = this.installations.find(
        (element) => element.installation_name.trim() === item.site.trim()
      );

      if (!installation) {
        console.warn("No installation found for site:", item.site);
        return;
      }

      const installId = installation.installation_id;

      this.$store.commit("SET_CUR_INSTALL_ID", installId);

      this.$router.push(
        `/smart-guard/${installId}?selected_date=${this.selected_date}`
      );
    },

    formatMessage(message) {
      if (!message) return "";

      // Split into lines and remove empty ones
      const lines = message.split(/\r?\n/).filter((line) => line.trim() !== "");

      if (lines.length === 0) return message;

      // Check if the first line looks like HTML (a heading or <b> tag)
      const firstLine = lines[0];
      const hasHtmlHeading = /<h\d>|<b>/i.test(firstLine);

      let title = "";
      let listStartIndex = 0;

      if (hasHtmlHeading) {
        // Use it as-is
        title = firstLine;
        listStartIndex = 1;
      } else {
        return `<li>${lines[0]}</li>`;
      }

      // Wrap remaining lines as list items
      const listItems = lines
        .slice(listStartIndex)
        .map((line) => `<li>${line}</li>`)
        .join("");

      return `
    <div>
      ${title}
      ${listItems ? `<ul>${listItems}</ul>` : ""}
    </div>
  `;
    },
    cancelDateRange() {
      // Restore previous confirmed values
      this.tempDateRange = [...this.dateRange];
      this.menuRange = false;
    },

    async validateDateRange() {
      if (this.tempDateRange.length !== 2) {
        return;
      }

      this.dateRange = [...this.tempDateRange].sort();
      this.activeDateRange = [...this.dateRange];
      this.menuRange = false;
      await this.loadAlarms();
    },

    async loadAlarms() {
      if (!this.activeDateRange || this.activeDateRange.length !== 2) return;
      this.loading = true;
      try {
        const response = await api.getlistalarmsrange({
          alarms: this.selected_site_id,
          start_date: this.activeDateRange[0],
          end_date: this.activeDateRange[1],
          country_lang_code: this.$root.$i18n.locale,
        });
        if (response && response.data) {
          this.items = this.mapAlarms(response.data);
        }
      } catch (error) {
        console.log();
      } finally {
        this.loading = false;
      }
    },
    onMenuChange(open) {
      if (open) {
        this.tempDateRange = [...this.dateRange];
      }
    },
  },
};
</script>

<style>
.v-data-table > .v-data-table__wrapper > table > tbody > tr > td,
.v-data-table > .v-data-table__wrapper > table > tfoot > tr > td,
.v-data-table > .v-data-table__wrapper > table > thead > tr > td {
  font-size: 0.75rem;
  height: 45px;
  line-height: 1.2;
}
#sys_acq > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#env_res > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#inv > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#field_mod > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2),
#alm_inc > div:nth-child(1) > table:nth-child(1) > thead:nth-child(2) {
  height: 50px;
  vertical-align: middle;
  background-color: #f7f7f7;
}

.table-text {
  font-family: Roboto, sans-serif;
  font-size: 0.75rem;
  font-weight: 400;
  text-align: left;
}

.text-subtitle-3 {
  font-size: 0.775rem !important;
  font-weight: 500;
  line-height: 1.25rem;
  letter-spacing: 0.0071428571em !important;
  font-family: Roboto, sans-serif !important;
  color: grey;
}
.message-content ul {
  margin-top: 4px;
  margin-bottom: 0;
  padding-left: 20px;
  list-style-type: disc; /* standard bullets */
}

.message-content li {
  line-height: 1.3rem;
  margin-bottom: 4px;
}

.message-content h3 {
  margin-bottom: 6px;
  font-weight: bold;
}
.v-menu__content {
  min-width: 290px !important;
}
</style>
